<template>
  <div v-bind:id="id" class="modal" v-bind:class="{active: showModal}" v-show="showModal">
    <div class="modal-header">
      <h3></h3>
      <a href="javascript:void(0)" class="btn-close modal-close" v-on:click="closeModal" aria-label="閉じる"></a>
    </div>
    <div class="modal-body" v-bind:style="{'max-height': maxHeight + 'px'}">
      <div class="announcement-header">
        <div class="date">{{ modalProps.date }}</div>
        <div class="title">{{ modalProps.title }}</div>
      </div>
      <div class="announcement-body" style="white-space: pre-line">
        <img v-bind:src="modalProps.imageURL" v-bind:alt="modalProps.title" v-if="modalProps.imageURL">
        <p v-html="modalProps.body"></p>
      </div>
    </div>
  </div>
</template>

<script>
  import ModalView from '../components/modal-view'
  import VueTypes from 'vue-types'

  const isNullable = { validator: (value) => value === null }

  export default {
    name: 'AnnouncementModal',
    extends: ModalView,
    props: {
      modalProps: VueTypes.shape({
        date: VueTypes.string,
        title: VueTypes.string,
        body: VueTypes.string,
        imageURL: VueTypes.oneOfType([VueTypes.string, isNullable.value])
      }).def({})
    },
    data () {
      return {}
    },
    methods: {},
    watch: {},
  }
</script>
